module.exports = __webpack_public_path__ + "static/media/chats-active.0a8b2237.svg";